<template>
  <a-config-provider :locale="locale">
    <router-view />
  </a-config-provider>
</template>

<script>
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { mapState } from 'vuex'
import { languages } from '@/locales/'

import en_US from 'ant-design-vue/lib/locale-provider/en_US'
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN'

const messages = Object.assign(languages)

const locales = {
  'en-US': en_US,
  'zh-CN': zh_CN,
}

Vue.use(VueI18n)
export const i18n = new VueI18n({
  locale: 'en-US',
  fallbackLocale: 'en-US',
  messages: messages,
})

export default {
  name: 'Localization',
  mounted() {
    this.$i18n.locale = this.settings.locale
  },
  computed: {
    ...mapState(['settings']),
    locale() {
      return locales[this.settings.locale]
    },
  },
  watch: {
    'settings.locale': function (value) {
      this.$i18n.locale = value
    },
  },
}
</script>
